export var KYBProgressStatusEnum = /*#__PURE__*/ function(KYBProgressStatusEnum) {
    KYBProgressStatusEnum["NotStarted"] = "NotStarted";
    KYBProgressStatusEnum["DetailsNeeded"] = "DetailsNeeded";
    KYBProgressStatusEnum["AwaitingDecision"] = "AwaitingDecision";
    KYBProgressStatusEnum["AwaitingAutomaticDecision"] = "AwaitingAutomaticDecision";
    KYBProgressStatusEnum["AwaitingManualReview"] = "AwaitingManualReview";
    KYBProgressStatusEnum["Approved"] = "Approved";
    KYBProgressStatusEnum["Declined"] = "Declined";
    KYBProgressStatusEnum["Errored"] = "Errored";
    return KYBProgressStatusEnum;
}({});
// Helper functions for KYBProgressStatusEnum
export const KYBProgressStatusHelpers = {
    /**
     * Checks if the status is any of the awaiting decision states
     * @param status The KYB progress status to check
     * @returns true if the status is any awaiting decision state
     */ isAwaitingDecision (status) {
        return [
            "AwaitingDecision",
            "AwaitingAutomaticDecision",
            "AwaitingManualReview"
        ].includes(status);
    },
    isApproved (status) {
        return status === "Approved";
    }
};
